/** Private Use unicodes for hash mapping our html tags */
export const unicodes = [
  '\uE000',
  '\uE001',
  '\uE002',
  '\uE003',
  '\uE004',
  '\uE005',
  '\uE006',
  '\uE007',
  '\uE008',
  '\uE009',
  '\uE00A',
  '\uE00B',
  '\uE00C',
  '\uE00D',
  '\uE00E',
  '\uE00F',
  '\uE010',
  '\uE011',
  '\uE012',
  '\uE013',
  '\uE014',
  '\uE015',
  '\uE016',
  '\uE017',
  '\uE018',
  '\uE019',
  '\uE01A',
  '\uE01B',
  '\uE01C',
  '\uE01D',
  '\uE01E',
  '\uE01F',
  '\uE020',
  '\uE021',
  '\uE022',
  '\uE023',
  '\uE024',
  '\uE025',
  '\uE026',
  '\uE027',
  '\uE028',
  '\uE029',
  '\uE02A',
  '\uE02B',
  '\uE02C',
  '\uE02D',
  '\uE02E',
  '\uE02F',
  '\uE030',
  '\uE031',
  '\uE032',
  '\uE033',
  '\uE034',
  '\uE035',
  '\uE036',
  '\uE037',
  '\uE038',
  '\uE039',
  '\uE03A',
  '\uE03B',
  '\uE03C',
  '\uE03D',
  '\uE03E',
  '\uE03F',
  '\uE040',
  '\uE041',
  '\uE042',
  '\uE043',
  '\uE044',
  '\uE045',
  '\uE046',
  '\uE047',
  '\uE048',
  '\uE049',
  '\uE04A',
  '\uE04B',
  '\uE04C',
  '\uE04D',
  '\uE04E',
  '\uE04F',
  '\uE050',
  '\uE051',
  '\uE052',
  '\uE053',
  '\uE054',
  '\uE055',
  '\uE056',
  '\uE057',
  '\uE058',
  '\uE059',
  '\uE05A',
  '\uE05B',
  '\uE05C',
  '\uE05D',
  '\uE05E',
  '\uE05F',
  '\uE060',
  '\uE061',
  '\uE062',
  '\uE063',
  '\uE064',
  '\uE065',
  '\uE066',
  '\uE067',
  '\uE068',
  '\uE069',
  '\uE06A',
  '\uE06B',
  '\uE06C',
  '\uE06D',
  '\uE06E',
  '\uE06F',
  '\uE070',
  '\uE071',
  '\uE072',
  '\uE073',
  '\uE074',
  '\uE075',
  '\uE076',
  '\uE077',
  '\uE078',
  '\uE079',
  '\uE07A',
  '\uE07B',
  '\uE07C',
  '\uE07D',
  '\uE07E',
  '\uE07F',
];

export const unicodeRegex = /[\uE000\uE001\uE002\uE003\uE004\uE005\uE006\uE007\uE008\uE009\uE00A\uE00B\uE00C\uE00D\uE00E\uE00F\uE010\uE011\uE012\uE013\uE014\uE015\uE016\uE017\uE018\uE019\uE01A\uE01B\uE01C\uE01D\uE01E\uE01F\uE020\uE021\uE022\uE023\uE024\uE025\uE026\uE027\uE028\uE029\uE02A\uE02B\uE02C\uE02D\uE02E\uE02F\uE030\uE031\uE032\uE033\uE034\uE035\uE036\uE037\uE038\uE039\uE03A\uE03B\uE03C\uE03D\uE03E\uE03F\uE040\uE041\uE042\uE043\uE044\uE045\uE046\uE047\uE048\uE049\uE04A\uE04B\uE04C\uE04D\uE04E\uE04F\uE050\uE051\uE052\uE053\uE054\uE055\uE056\uE057\uE058\uE059\uE05A\uE05B\uE05C\uE05D\uE05E\uE05F\uE060\uE061\uE062\uE063\uE064\uE065\uE066\uE067\uE068\uE069\uE06A\uE06B\uE06C\uE06D\uE06E\uE06F\uE070\uE071\uE072\uE073\uE074\uE075\uE076\uE077\uE078\uE079\uE07A\uE07B\uE07C\uE07D\uE07E\uE07F]/;
